﻿{
  "favoriteBoardmakerSoftware": "Software de Boardmaker favorito",
  "planDetailsStartTrial": "¡Inicie su prueba gratuita hoy y tendrá acceso por 30 días!",
  "community": {
    "summary": "¡Aproveche los materiales educativos accesibles ya preparados que comparten los padres, educadores y terapeutas como usted! Ahorre tiempo buscando y filtrando las actividades y plantillas; luego, solo agréguelas a su cuenta y estará listo para editarlas y usarlas con su software de Boardmaker favorito. Cuenta con más de 60 000 actividades interactivas e impresas GRATIS y más de 500 000 miembros. ¿Qué está esperando?",
    "topReasons": {
      "header": "Razones principales para suscribirse a myBoardmaker Community",
      "points": [
        "Podrá compartir las actividades geniales que cree.",
        "Podrá utilizar funciones de búsqueda potentes para encontrar justo lo que necesita.",
        "Podrá encontrar actividades que se crearon de manera profesional por el equipo educativo de Boardmaker.",
        "Podrá buscar actividades alineadas con las normas Common Core.",
        "Podrá unirse a grupos específicos en función de sus intereses."
      ]
    },
    "summaryEnd": "Comparta y explore los materiales interactivos e impresos que brindan apoyo de conducta y promueven la independencia del estudiante, así como el desarrollo de habilidades. Acceda a todo esto de manera GRATUITA.",
    "features": [
      {
        "featureTitle": "Encuentre",
        "featureDescription": "Descubra un plan de estudios adaptado, horarios visuales, tableros de comunicación, actividades alineadas con las normas educativas y otros apoyos que los padres, terapeutas y educadores han desarrollado y utilizado."
      },
      {
        "featureTitle": "Comparta",
        "featureDescription": "Cargue las actividades que haya creado, participe en discusiones, cree grupos públicos y privados para compartir, y mucho más."
      },
      {
        "featureTitle": "Use",
        "featureDescription": "Almacene sus actividades en línea y acceda a ellas desde cualquier computadora."
      },
      {
        "featureTitle": "Conéctese",
        "featureDescription": "Conéctese con otras personas que enseñan la misma materia o nivel de grado, intercambie ideas con padres que enfrentan los mismos desafíos que usted y comparta las soluciones que ha creado."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o posterior"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o posterior"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o posterior"]
      ],
      "browser": [
        ["Chrome", "v49.0", "actual"],
        ["Firefox", "v38.0", "actual"],
        ["Safari", "v11.0", "actual"],
        ["Edge", "v83.0.478.45", "actual"],
        ["Internet Explorer", "v10.0", "v11.0 o posterior"]
      ]
    }
  },
  "personal": {
    "summary": "Lleve el poder de Boardmaker a su hogar con facilidad. Una suscripción a myBoardmaker Personal le da la capacidad de desempeñar un papel activo en el éxito de su hijo, ya que le brinda coherencia entre el hogar, la escuela y la terapia. Además, es una opción para ampliar el aprendizaje más allá de la jornada escolar e incluso del año escolar. Conéctese con otros padres de Boardmaker Community para compartir sus creaciones y obtener ideas para muchas más.",
    "topReasons": {
      "header": "Principales razones para suscribirse a myBoardmaker Personal",
      "points": [
        "Podrá trasladar las actividades interesantes e interactivas a cualquier computadora o iPad.",
        "Podrá imprimir las actividades cuando las necesite.",
        "Como padre, podrá desempeñar un papel activo en el aprendizaje de su hijo en casa.",
        "Podrá llevar los materiales divertidos e interesantes a donde sea que necesite ir y crear o editar las actividades desde cualquier computadora."
      ]
    },
    "summaryEnd": "¡Comience su prueba gratuita hoy mismo y tendrá acceso total por 30 días!",
    "features": [
      {
        "featureTitle": "Cree y edite",
        "featureDescription": "Cree y edite actividades que se han adaptado a símbolos; por ejemplo, horarios visuales para planificar su día, libros y materiales de aprendizaje individualizados y apoyos de conducta. Con una biblioteca de más de 80 000 símbolos para elegir, además de otros nuevos que se agregan cada dos semanas, las posibilidades son infinitas. ¿Necesita más? Utilice nuestra opción de búsqueda web para incorporar cualquier archivo multimedia a su proyecto."
      },
      {
        "featureTitle": "Imprima y reproduzca",
        "featureDescription": "Imprima sus propias actividades, o cualquiera que encuentre en Boardmaker Community, directo desde su navegador web para que las use con su hijo. ¿Busca aumentar la participación? Pruebe nuestras plantillas y actividades interactivas. Los niños y los padres pueden reproducir las actividades fácilmente a través de la aplicación gratuita Student Center en su tableta o dispositivo de comunicación."
      },
      {
        "featureTitle": "Enseñe y amplíe",
        "featureDescription": "Impulse las habilidades lingüísticas y de alfabetización de su hijo gracias al acceso a nuestros tres programas curriculares fáciles de usar. Comience con Core First Learning, una herramienta que ayuda a su hijo a aprender el significado, el uso y la ubicación de las palabras esenciales que se usan muy frecuentemente. ¡Ideal para las personas que utilizan los sistemas de comunicación aumentativa con base en el vocabulario esencial o para aquellos que están aprendiendo a leer! Aplique estas nuevas habilidades a la literatura del nivel de grado al interactuar con Book Bridge, y luego comience a desarrollar el conocimiento extralingüístico a través de la exploración de la historia, la geografía, la vida y la cultura con Expedition Education."
      },
      {
        "featureTitle": "Busque y comparta",
        "featureDescription": "¿Por qué reinventar la rueda? Elija entre más de 60 000 actividades interactivas e impresas preestablecidas y 1100 grupos públicos categorizados en Boardmaker Community, la comunidad de intercambio más grande de su tipo a nivel mundial. También puede cargar las actividades que haya creado en su cuenta de myBoardmaker Community y compartirlas con los padres y terapeutas o con el equipo de apoyo de su alumno."
      },
      {
        "featureTitle": "Supervisar y realizar el seguimiento",
        "featureDescription": "Supervise y realice el seguimiento del progreso de su hijo mientras trabaja en las actividades para garantizar su éxito y para que pueda determinar cuál es el enfoque más eficaz."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o posterior"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o posterior"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o posterior"]
      ],
      "browser": [
        ["Chrome", "v49.0", "actual"],
        ["Firefox", "v38.0", "actual"],
        ["Safari", "v11.0", "actual"],
        ["Edge", "v83.0.478.45", "actual"],
        ["Internet Explorer", "v10.0", "v11.0 o posterior"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional es el sistema más completo para los maestros de educación especial, patólogos del habla y el lenguaje, terapeutas ocupacionales, terapeutas conductuales, entre otros. Sirve para encontrar, crear, organizar y brindar apoyos visuales personalizados, comunicación con base en símbolos y actividades de terapia que abordan las necesidades de los estudiantes que forman parte de su salón de clases o de su lista de casos.",
    "topReasons": {
      "header": "Principales razones para suscribirse a myBoardmaker Professional",
      "points": [
        "Podrá administrar y asignar las actividades de los estudiantes desde cualquier lugar y en cualquier computadora.",
        "Podrá utilizar la gran biblioteca de actividades de muestra alineadas con las normas o crear la suya propia.",
        "Los estudiantes podrán acceder a las actividades de instrucción desde cualquier computadora o iPad en la escuela o en su hogar.",
        "Podrá recopilar la información y realizar el seguimiento del progreso de los estudiantes hacia los objetivos del PEI y las nomas educativas.",
        "Podrá utilizar las herramientas integradas para colaborar y compartir con los otros miembros del equipo."
      ]
    },
    "summaryEnd": "¡Comience su prueba gratuita hoy mismo y tendrá acceso total por 30 días!",
    "features": [
      {
        "featureTitle": "Cree y edite",
        "featureDescription": "Cree y edite actividades que se han adaptado a símbolos; por ejemplo, horarios visuales para planificar su día, libros y materiales de aprendizaje individualizados y apoyos de conducta. Con una biblioteca de más de 80 000 símbolos para elegir, además de otros nuevos que se agregan cada dos semanas, las posibilidades son infinitas. ¿Necesita más? Utilice nuestra opción de búsqueda web para incorporar cualquier archivo multimedia a su proyecto."
      },
      {
        "featureTitle": "Imprima y reproduzca",
        "featureDescription": "Imprima sus propias actividades, o cualquiera que encuentre en Boardmaker Community, directo desde su navegador web para que las use con su hijo. ¿Busca aumentar la participación? Pruebe nuestras plantillas y actividades interactivas. Los niños y los padres pueden reproducir las actividades fácilmente a través de la aplicación gratuita Student Center en su tableta o dispositivo de comunicación."
      },
      {
        "featureTitle": "Enseñe y amplíe",
        "featureDescription": "Ayude a su alumno a dar el siguiente paso en su travesía educativa gracias al acceso a tres programas curriculares sólidos alineados con las normas. Acceda a Boardmaker Instructional Solutions que viene con su suscripción a myBoardmaker e incluye más de 140 planes de lecciones paso a paso, más de 1500 actividades diferenciadas y alineadas con las normas, más de 300 libros imprimibles y accesibles, herramientas de administración del aula, cuestionarios, juegos, recetas, manualidades, ¡y más!"
      },
      {
        "featureTitle": "Busque y comparta",
        "featureDescription": "¿Por qué reinventar la rueda? Elija entre más de 60 000 actividades interactivas e impresas preestablecidas y 1100 grupos públicos categorizados en Boardmaker Community, la comunidad de intercambio más grande de su tipo a nivel mundial. También puede cargar las actividades que haya creado en su cuenta de myBoardmaker Community y compartirlas con los padres y terapeutas o con el equipo de apoyo de su alumno."
      },
      {
        "featureTitle": "Supervisar y realizar el seguimiento",
        "featureDescription": "Supervise y realice el seguimiento del progreso de su hijo mientras trabaja en las actividades para garantizar su éxito y para que pueda determinar cuál es el enfoque más eficaz."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o posterior"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o posterior"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o posterior"]
      ],
      "browser": [
        ["Chrome", "v49.0", "actual"],
        ["Firefox", "v38.0", "actual"],
        ["Safari", "v11.0", "actual"],
        ["Edge", "v83.0.478.45", "actual"],
        ["Internet Explorer", "v10.0", "v11.0 o posterior"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Online Organization apoya a su equipo multidisciplinario, ya que ofrece actividades adaptadas, apoyo de conducta y medición del progreso hacia las normas y los objetivos. \n\n El sistema de myBoardmaker con base en la nube proporciona un marco para la coherencia y la colaboración en toda la organización y permite que los miembros del personal trabajen desde cualquier lugar. Además, les da acceso a una biblioteca con más de 60 000 actividades preestablecidas, tres programas curriculares completos y más de 80 000 símbolos de comunicación con imágenes para impulsar la planificación de sus lecciones. Ahora, su personal puede entregar de manera rápida las actividades impresas e interactivas a sus estudiantes o clientes usando el Boardmaker Student Center para ampliar el aprendizaje y la terapia, ¡todo al alcance de un clic! \n\n Vea el uso que le da el personal y mejore la eficiencia en toda su organización gracias a que puede administrar las cuentas y la información de forma centralizada, junto con las herramientas avanzadas para compartir y colaborar.",
    "topReasons": {
      "header": "Principales razones para suscribirse a myBoardmaker Organization",
      "points": [
        "El sistema con base en la nube proporcionará coherencia y colaboración a lo largo de toda la organización y permitirá que los miembros del personal trabajen desde cualquier lugar.",
        "Podrá contar con una amplia biblioteca de actividades de muestra ya alineadas con las normas de preparación universitaria y profesional y con las normas específicas de su estado.",
        "Los estudiantes podrán acceder a las actividades de instrucción desde cualquier computadora y en cualquier lugar.",
        "Podrá relacionar las actividades con los objetivos del PEI para demostrar los logros del estudiante.",
        "Podrá acceder de manera inmediata a la información sobre el rendimiento de los estudiantes y el uso que le da el personal, todo desde un solo sistema."
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Cree y edite",
        "featureDescription": "Cree y edite actividades que se han adaptado a símbolos; por ejemplo, horarios visuales para planificar su día, libros y materiales de aprendizaje individualizados y apoyos de conducta. Con una biblioteca de más de 80 000 símbolos para elegir, además de otros nuevos que se agregan cada dos semanas, las posibilidades son infinitas. ¿Necesita más? Utilice nuestra opción de búsqueda web para incorporar cualquier archivo multimedia a su proyecto."
      },
      {
        "featureTitle": "Imprima y reproduzca",
        "featureDescription": "Imprima sus propias actividades, o cualquiera que encuentre en Boardmaker Community, directo desde su navegador web. ¿Busca aumentar la participación? Anime a su equipo a probar nuestras plantillas y actividades interactivas. Los estudiantes pueden reproducir las actividades de manera sencilla a través de la aplicación gratuita Student Center, a la cual tienen acceso total sin necesitar de una conexión a Internet."
      },
      {
        "featureTitle": "Enseñe y amplíe",
        "featureDescription": "Brinde a su personal acceso a tres programas curriculares sólidos alineados con las normas, los cuales se incluyen en su suscripción a myBoardmaker Organization. Boardmaker Instructional Solutions incluye más de 140 planes de lecciones paso a paso, más de 1500 actividades diferenciadas alineadas con las normas, más de 300 libros imprimibles y accesibles, herramientas de administración del aula, cuestionarios, juegos, recetas, manualidades, ¡y más!"
      },
      {
        "featureTitle": "Asigne y realice el seguimiento",
        "featureDescription": "Con una cuenta de myBoardmaker Organization, el personal puede asignar actividades personalizadas y separadas de acuerdo con el nivel correspondiente para un número ilimitado de estudiantes. De esta manera, puede realizar el seguimiento de su progreso individual teniendo como referencia los objetivos del PEI y las normas estatales y locales. Luego, pueden usar nuestra herramienta de seguimiento del progreso para consultar de manera rápida el desempeño de sus estudiantes e informar fácilmente sobre su éxito. También se realiza el seguimiento de las actividades que se completaron en el hogar para que puedan administrar las tareas de manera eficaz y colaborar con la familia del niño para ampliar el aprendizaje más allá del aula."
      },
      {
        "featureTitle": "Busque y comparta",
        "featureDescription": "¿Por qué reinventar la rueda? Elija entre más de 60 000 actividades interactivas e impresas preestablecidas y 1100 grupos públicos categorizados en Boardmaker Community, la comunidad de intercambio más grande de su tipo a nivel mundial. También puede cargar las actividades que haya creado en su cuenta de myBoardmaker Community y compartirlas con los padres y terapeutas o con el equipo de apoyo de su alumno."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Ahorro de costos",
        "advantagePoints": [
          "Paquetes personalizados y exclusivos para organizaciones que permiten el uso de 5 cuentas",
          "Servicios con base en la nube que permiten una fácil reasignación de las licencias como transacción de personal",
          "Precios por volumen",
          "Paquetes multiproductos",
          "Ahorro por varios años"
        ]
      },
      {
        "advantageTitle": "Éxito para todos",
        "advantagePoints": [
          "Las actividades preestablecidas y que se basan en la investigación garantizan resultados positivos y medibles.",
          "Siguiendo los principios del Diseño Universal para el Aprendizaje, nuestras actividades y materiales educativos adaptados hacen que las personas con diversas habilidades puedan alcanzar los objetivos de aprendizaje.",
          "Los planes de estudios adaptados brindan igualdad de acceso para todos.",
          "Cuenta con recursos disponibles para recoger las mejores prácticas de los expertos, lo que garantiza que usted aprovechará al máximo sus soluciones."
        ]
      },
      {
        "advantageTitle": "Compatible con las normas y los requisitos",
        "advantagePoints": [
          "Son soluciones diseñadas específicamente para enseñar y para medir el progreso hacia las normas de preparación universitaria y profesional.",
          "Una amplia gama de soluciones que satisfacen los requisitos del Diseño Universal para el Aprendizaje, del programa Every Child Succeeds y de la Ley para la Educación de Individuos con Discapacidades.",
          "Realice el seguimiento e informe sobre el progreso hacia los objetivos del Plan de Educación Individual de manera automática a través de paneles de datos."
        ]
      },
      {
        "advantageTitle": "Implementación sencilla de la organización",
        "advantagePoints": [
          "Habilita a los administradores para entregar e implementar cuentas de forma remota en segundos.",
          "Presenta opciones flexibles y escalables para la implementación de las organizaciones.",
          "Todas las soluciones con base en la nube se alojan en un centro de datos de nivel 1 altamente seguro.",
          "Provee actualizaciones automáticas gratuitas con base en la nube con funciones y recursos nuevos e interesantes."
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o posterior"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o posterior"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o posterior"]
      ],
      "browser": [
        ["Chrome", "v49.0", "actual"],
        ["Firefox", "v38.0", "actual"],
        ["Safari", "v11.0", "actual"],
        ["Edge", "v83.0.478.45", "actual"],
        ["Internet Explorer", "v10.0", "v11.0 o posterior"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "¡Ha llegado la próxima generación del software de Boardmaker!  Boardmaker 7 toma las mejores características de todas las versiones anteriores de Boardmaker y las integra en una aplicación que incluye diversas plataformas y que se presenta en varios idiomas.  Boardmaker 7 cuenta con una interfaz de usuario optimizada que coloca las herramientas que necesita al alcance de su mano.  Si bien incluye los símbolos PCS más recientes, es compatible con todas sus actividades y tableros antiguos. Este nuevo software le permitirá crear y ofrecer un plan de estudios adaptado y soportes de comunicación más rápido que nunca.",
    "topReasons": {
      "header": "Principales razones para comprar el software Boardmaker 7",
      "points": [
        "Podrá editar, imprimir y reproducir todos sus archivos antiguos de Boardmaker.",
        "Podrá acceder a una interfaz intuitiva y moderna con sugerencias y materiales de capacitación integrados.",
        "Podrá tener plantillas increíbles que se pueden personalizar de manera rápida y fácil.",
        "Podrá encontrar rápido los símbolos y las imágenes que necesita."
      ]
    },
    "summaryEnd": "¡Descargue hoy su prueba gratuita de 30 días!",
    "features": [
      {
        "featureTitle": "Abre todo lo que ha creado",
        "featureDescription": "No pierda todos sus años de arduo trabajo. Con el software Boardmaker 7, puede abrir cualquier archivo creado con Boardmaker v5, Boardmaker v6 o Boardmaker Studio.  La conversión es rápida y precisa, por lo que incluso las actividades interactivas complejas funcionarán y tendrán el mismo aspecto que las originales."
      },
      {
        "featureTitle": "Fácil, fácil, fácil",
        "featureDescription": "¡Los usuarios han hablado!  La interfaz del software Boardmaker 7, que se basa en pruebas exhaustivas con usuarios como usted, es moderna, acogedora e intuitiva.  Las sugerencias y los materiales de capacitación incorporados le brindan la confianza para explorar, expandir sus habilidades y, lo más importante, apoyar a sus estudiantes."
      },
      {
        "featureTitle": "Veloz/ahorra tiempo",
        "featureDescription": "Se sorprenderá de la amplitud y profundidad de lo que puede lograr en solo unos minutos con plantillas que se rediseñaron para las actividades tanto impresas como interactivas.  Terminará ese horario o esa historia social al instante, lo que le permitirá dirigir su atención a los estudiantes que están bajo su cargo.  Boardmaker también facilita la personalización de lo que ha creado para que tenga la combinación ideal de velocidad y flexibilidad."
      },
      {
        "featureTitle": "Un búsqueda de símbolos superior",
        "featureDescription": "Los símbolos son nuestra esencia. Boardmaker 7 cuenta con una función de búsqueda de símbolos mejorada y una forma intuitiva de buscar símbolos por categoría, pero eso no es todo.  Además, puede buscar partes de palabras, palabras que riman, fonemas individuales y patrones de consonantes y vocales. ¡Esta es la herramienta de búsqueda más poderosa que hay disponible!  Y en caso de que no pueda encontrar ese símbolo especial, la búsqueda web integrada y las herramientas de la cámara le permiten agregar fotos de manera rápida y fácil."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 o posterior"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o posterior"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o posterior"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 o posterior"],
        ["Android", "Dispositivos de la serie T de Tobii Dynavox", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I-15."
        ]
      ]
    }
  }
}
